import React, { useState } from 'react';
import { Paper, Typography, Grid, TextField, Card, Button } from '@material-ui/core';
import {
    Save as SaveIcon
} from '@material-ui/icons';
import { useDataProvider } from 'react-admin';
export default function AddCluster(props) {
    // const [clustertype, setClusterType] = useState("");
    const [name, setName] = useState("")
    const [cannonicalname, setCannonicalName] = useState("")
    const dataProvider = useDataProvider();
    // const handleClusterTypeInput = (e) => {
    //     setClusterType(e.target.value);
    //     console.log(clustertype)
    // }
    const handleNameInput = (e) => {
        setName(e.target.value);
    }
    const handleCannonicalNameInput = (e) => {
        setCannonicalName(e.target.value);
    }


    const handleSubmitCluster = () => {
        dataProvider('CREATE', 'nodes', {
            data: {
                name: name,
                cannonicalName: cannonicalname,
                parentId:props.location.state.record.id,
            }
        });

    };

    return (
        <div style={{ margin: 10 }} >
            <Paper>
                <Grid container spacing={1} style={{ margin: 10 }}  item xs={12} sm={12} xl={12}  lg={12} >
                    <Grid item xs={12} sm={12} xl={12}  lg={12}>
                        <Typography gutterBottom variant="subtitle2" >
                            Add Cluster
                 </Typography>
                    </Grid>
                    {/* <Grid item xs={6} sm={3}>
                        <TextField id="outlined-basic" label="Cluster Type" variant="outlined" margin="normal" fullWidth  onChange={handleClusterTypeInput} />
                    </Grid>
                    <Grid item xs={6} sm={9}></Grid> */}
                   
                    <Grid item xs={6} sm={3} xl={3}  lg={3}  >
                        <TextField id="outlined-basic" label="Name" variant="outlined" margin="normal" onChange={handleNameInput} fullWidth  />
                    </Grid>
                    <Grid item xs={6} sm={9} xl={9}  lg={9}>
                    </Grid>
                   
                    <Grid item xs={6} sm={3} xl={3}  lg={3}>
                        <TextField id="outlined-basic" label="Cannonical Name" variant="outlined" margin="normal"  onChange={handleCannonicalNameInput} fullWidth />
                    </Grid>
                    <Grid item xs={6} sm={9} xl={9}  lg={9}>
                    </Grid>
                    <Grid item xs={6} sm={3} xl={3}  lg={3}>
                        <TextField id="outlined-basic" label="Parent Name" value={props.location.state.record.name} variant="outlined" margin="normal" disabled fullWidth />
                    </Grid>
                    <Grid item xs={6} sm={9} xl={9}  lg={9}>
                    </Grid>
                    <Grid item xs={6} sm={3} xl={3}  lg={3}>
                        <TextField id="outlined-basic" label="Level" value={props.location.state.record.level} variant="outlined" margin="normal" disabled fullWidth />
                    </Grid>
                    <Grid item xs={6} sm={9} xl={9}  lg={9}>
                    </Grid>
                </Grid>
                <Card style={{ padding: 15 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        endIcon={<SaveIcon />}
                        onClick={handleSubmitCluster}
                        href="#/nodes"
                    >
                        Add
                 </Button>    
                <a>  </a>
                 <Button 
                        variant="contained"
                        color="secondary"
                        size="large"
                        href="#/nodes"
                    >
                        Back
                 </Button>
                </Card>
            </Paper>
        </div>
    )
}